(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.HanaBoxCatalog = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  const PROFILE_KEYS = {
    'Brotes + rojeces': 'breakouts-redness',
    'Grasa + poros': 'oily-pores',
    'Sensible + barrera': 'sensitive-barrier',
    'Deshidratación': 'dehydration',
    'Manchas + tono': 'spots-tone',
    'Firmeza + renovación': 'firmness-renewal'
  };

  const STEP_KEYS = {
    'Primera limpieza': 'oil',
    'Limpieza acuosa': 'cleanse',
    'Tónico / esencia': 'prep',
    'Tónico / tratamiento': 'prep',
    'Sérum / ampolla': 'treat',
    'Hidratación': 'moisturise',
    'Protección solar': 'protect'
  };

  const PROFILE_FALLBACKS = {
    'dry-nutrition': ['dehydration', 'sensitive-barrier'],
    'breakouts-redness': ['oily-pores', 'sensitive-barrier', 'dehydration'],
    'oily-pores': ['sensitive-barrier', 'dehydration'],
    'sensitive-barrier': ['dehydration'],
    'spots-tone': ['sensitive-barrier', 'dehydration'],
    'firmness-renewal': ['dehydration', 'sensitive-barrier'],
    'dehydration': ['sensitive-barrier']
  };

  const firstValue = raw => {
    const value = String(raw || '').trim();
    if (!value) return '';
    if (value[0] === '[') {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return String(parsed[0] || '').trim();
      } catch (_) {
        return value;
      }
    }
    return value;
  };

  const profileKey = label => PROFILE_KEYS[firstValue(label)] || '';
  const stepKey = label => STEP_KEYS[firstValue(label)] || '';

  const candidatesFor = (configMap, profile, step) => {
    const exact = configMap.get(`${profile}:${step}`) || [];
    if (exact.length) return exact;
    for (const fallback of PROFILE_FALLBACKS[profile] || []) {
      const candidates = configMap.get(`${fallback}:${step}`) || [];
      if (candidates.length) return candidates;
    }
    return [];
  };

  return { profileKey, stepKey, candidatesFor };
});
